import { ControlItem } from "./control-item";

export class DeviceTimersInfo {
	Language: string;
	Name: string;
	AccessRights: string;
	ControlItem: ControlItem;
	Max: number;
	Used: number;
}

export class DeviceSpecialDaysInfo {
	Language: string;
	Name: string;
	AccessRights: string;
	ControlItem: ControlItem;
	Max: number;
	Used: number;
}

export class DeviceTimersList {
	Meta: DeviceTimersMeta;
	Items: DeviceTimers[];
}

export class DeviceTimersMeta {
	Total: number;
	Count: number;
	Size: number;
	From: number;
}

export class DeviceTimers {
	Id: number;
	DeviceId: number;
	Mode: number;
	State: number;
	Position?: number;
	StartHour: number;
	StartMin: number;
	EndHour: number;
	EndMin: number;
	WeekMask: number;
	constructor() {
		this.Mode = 1;
		this.State = 0;
		this.StartHour = 0;
		this.StartMin = 0;
		this.EndHour = 1;
		this.EndMin = 0;
		this.WeekMask = 0;
	}
}

export class DeviceSpecialDaysList {
	Meta: DeviceTimersMeta;
	Items: DeviceSpecialDays[];
}

export class DeviceSpecialDays {
	Position: number;
	Mode: number;
	Year: number;
	Month: number;
	Day: number;
	StartHour: number;
	StartMin: number;
	EndHour: number;
	EndMin: number;
	constructor() {
		this.Mode = 0;
		this.StartHour = 0;
		this.StartMin = 0;
		this.EndHour = 1;
		this.EndMin = 0;
	}
}
